<template>
  <div class="row mt-lg-0 mt-3">
    <transition name="fade-right">
      <div v-if="mediumResImagesLoaded < portfolioImages.length - 2" class="high-res-images-loader">
        <div class="value">
          <span>{{
            Math.round(
              (mediumResImagesLoaded / portfolioImages.length) * 100
            )
          }}%</span>
          <span>{{ mediumResImagesLoaded }}/{{ portfolioImages.length }}</span>
          <span>of images</span>
        </div>
      </div>
    </transition>

    <div data-scroll-container class="col-16 align-items-start">
      <div data-scroll-section id="stick" class="row no-gutters align-items-lg-start align-items-end w-100">
        <div class="col-xxl-14 col-16 mt-xxl-15 mt-lg-10 align-self-lg-end" :class="{
          'col-lg-5 offset-xxl-2 offset-lg-3':
            $store.state.privatePortfolio.length > 1,
          'col-lg-8': $store.state.privatePortfolio.length <= 1,
        }">
          <div class="d-flex align-items-center">
            <p class="username pl-xl-3 pl-lg-1">
              <b class="font-weight-bold">Hello,</b> {{ user.name }} //
            </p>

            <button type="button" class="btn-logout ml-2" @click="logout">
              LOGOUT
            </button>
          </div>
        </div>

        <div v-if="$store.state.privatePortfolio.length > 1" data-scroll data-scroll-target="#stick" data-scroll-sticky class="col-xxl-2 col-lg-3 col-11 order-xxl-2 order-lg-3 lg-sticky pt-lg-sticky">
          <ul class="portfolio-menu">
            <li v-for="(category, index) in $store.state.privatePortfolio" :key="index">
              <router-link :to="{
                name: 'client-area',
                params: { category: category.slug },
              }">
                <span>{{ category.title }}</span>
              </router-link>

              <!-- <button
                type="button"
                :class="{ active: $route.params.category === category.slug }"
                @click="
                  goToRoute({
                    name: 'client-area',
                    params: { category: category.slug },
                  })
                "
              >
                <span>{{ category.title }}</span>
              </button> -->
            </li>
          </ul>
        </div>

        <!-- <div
          class="col-xxl-1 col-lg-8 order-xxl-4 order-lg-2 mt-xxl-5 mt-lg-10 mt-n4"
          :class="{
            'col-5': $store.state.privatePortfolio.length > 1,
            'col-16': $store.state.privatePortfolio.length <= 1,
          }"
        >
          <div class="ml-xxl-2"> -->
        <!-- <button
              v-if="portfolioImages.length > 0"
              type="button"
              title="download all photos"
              class="btn-download-all ml-xxl-0 ml-auto"
              @click="downloadAll"
            >
              <img
                src="/public/site/nickyeconomou/dist/images/download.svg"
                alt="download all"
              />
              <span>DOWNLOAD ALL PHOTOS</span>
            </button> -->

        <!-- <button
              type="button"
              class="btn-change-view ml-xxl-0 ml-auto mt-xxl-4 mt-lg-2 mt-4 d-xl-none"
              @click="toggleMasonryColumns"
            >
              change <br class="d-xxl-block d-none" />
              view
            </button> -->
        <!-- </div>
        </div> -->

        <div class="order-xxl-3 order-lg-4 mt-5" :class="{
          'col-lg-13': $store.state.privatePortfolio.length > 1,
          'col-xxl-15 col-16': $store.state.privatePortfolio.length <= 1,
        }">
          <div class="masonry" :class="[`columns-${masonryColumns}`, { active: showMasonry }]">
            <a data-fancybox="gallery" :data-caption="image.high.title" v-for="(image, index) in portfolioImages" :key="index" class="masonry-item" :href="image.high.src" :style="{ 'grid-row-end': `span ${image.low.height}` }">
              <img :src="image.low.src" class="img-low" @load="onLowResImageLoad" />
              <div class="img-loader"></div>
              <img :data-src="image.medium" class="img-medium" @load="showMediumResImage" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImagesListingMixin from "../images-listing-mixin";

// import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import { Fancybox } from "@fancyapps/ui";
import { privateGalleryOptions } from "../imports/fancyOptions";

export default {
  mixins: [ImagesListingMixin("privatePortfolio")],
  data() {
    return {
      user:
        typeof window.Laravel.user != "undefined"
          ? window.Laravel.user
          : {
            name: "",
            email: "",
          },
    };
  },
  methods: {
    downloadAll() {
      if (this.$route.params.category != "") {
        window.location.href =
          window.Laravel.uris.download + "/" + this.$route.params.category;
      }

      return this.gallery;
    },
    logout() {
      window.location.href = window.Laravel.uris.logout;
    },
  },
  mounted() {
    const getCurrentImageSrc = () => {
      const src = document.querySelector(".fancybox__carousel .fancybox__slide.is-selected .fancybox-image").getAttribute("src");
      const image = /[^/]*$/.exec(src)[0];
      return image;
    };

    privateGalleryOptions.on = {
      done: (fancybox) => {
        const image = getCurrentImageSrc();
        fancybox.footer.children['btn-download-image'].setAttribute("href", `/media/${image}`);
      },
      "Carousel.settle": (fancybox) => {
        const image = getCurrentImageSrc();
        fancybox.footer.children['btn-download-image'].setAttribute("href", `/media/${image}`);
      },
    };

    Fancybox.bind("[data-fancybox]", privateGalleryOptions);
  },
};
</script>

<style lang="scss">
@import "src/sass/variables";
@import "src/sass/mixins";
@import "node_modules/bootstrap/scss/vendor/rfs";

.username {
  @include font-size(0.75rem);
  font-weight: 300;
  line-height: 1.2;
  color: $black;
}

.btn-download-all {
  display: block;
  opacity: 1;
  position: relative;
  transition: opacity 250ms ease-in-out;

  img {
    width: 20px;
  }

  span {
    display: none;
    position: absolute;
    top: 50%;
    right: calc(100% + 10px);
    transform: translateY(-50%);
    font-size: 0.5rem;
    font-weight: 300;
    white-space: nowrap;
  }

  &:hover {
    opacity: 0.5;
  }
}

.btn-download-image {
  text-align: center;
  color: $white;
  display: inline-block;
  margin-bottom: 40px;

  img {
    width: 16px;
    position: relative;
    top: -1px;
    margin-right: 5px;
  }

  span {
    position: relative;
    font-weight: 300;
    font-size: 0.725rem;
    white-space: nowrap;
    color: $white;

    &::before {
      content: "";
      display: block;
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 0%;
      height: 1px;
      background: $white;
      transition: width 250ms ease-out;
    }
  }

  &:hover {
    span {
      &::before {
        width: 100%;
      }
    }
  }
}

// SM (576px)
@media only screen and (min-width: map-get($grid-breakpoints, "sm")) {
  .btn-download-all {
    span {
      display: inline-block;
    }
  }
}

// XXL (1367px)
@media only screen and (min-width: map-get($grid-breakpoints, "xxl")) {
  .btn-download-all {
    span {
      right: unset;
      top: 40px;
      left: 3px;
      transform: translate(-100%, 0%) rotate(-90deg);
      transform-origin: 100% 0%;
    }
  }
}
</style>